export class ConstantsDom {
    static readonly DOM_CHART_INV_BED_ND: string = 'chartInvBedNd'; 
    static readonly DOM_CHART_INV_BED_KB: string = 'chartInvBedKb'; 
    static readonly DOM_CHART_FB_JE_TP: string = 'chartFbJeTp';


    static readonly DOM_CHART_INV_BED_KB_JE_Q2_FKT: string = 'chartInvBedKbJeMQuadratFkt';


    static readonly DOM_CHART_JAEHRLICHE_GEB_KOST: string = 'chartJaehrlicheGebeudeKosten';

 
  }
  